var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#B9E1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5003 13.167H14.8337C14.3916 13.167 13.9677 13.3426 13.6551 13.6551C13.3426 13.9677 13.167 14.3916 13.167 14.8337V24.8337C13.167 25.2757 13.3426 25.6996 13.6551 26.0122C13.9677 26.3247 14.3916 26.5003 14.8337 26.5003H23.167C23.609 26.5003 24.0329 26.3247 24.3455 26.0122C24.6581 25.6996 24.8337 25.2757 24.8337 24.8337V14.8337C24.8337 14.3916 24.6581 13.9677 24.3455 13.6551C24.0329 13.3426 23.609 13.167 23.167 13.167H21.5003",
    stroke: "#0B54A0",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 18.1667H18.5833C18.2518 18.1667 17.9339 18.2984 17.6994 18.5328C17.465 18.7672 17.3333 19.0851 17.3333 19.4167C17.3333 19.7482 17.465 20.0661 17.6994 20.3006C17.9339 20.535 18.2518 20.6667 18.5833 20.6667H19.4167C19.7482 20.6667 20.0661 20.7984 20.3006 21.0328C20.535 21.2672 20.6667 21.5851 20.6667 21.9167C20.6667 22.2482 20.535 22.5661 20.3006 22.8005C20.0661 23.035 19.7482 23.1667 19.4167 23.1667H17.3333M19 23.1667V24M19 17.3333V18.1667M16.5 13.1667C16.5 12.7246 16.6756 12.3007 16.9882 11.9882C17.3007 11.6756 17.7246 11.5 18.1667 11.5H19.8333C20.2754 11.5 20.6993 11.6756 21.0118 11.9882C21.3244 12.3007 21.5 12.7246 21.5 13.1667C21.5 13.6087 21.3244 14.0326 21.0118 14.3452C20.6993 14.6577 20.2754 14.8333 19.8333 14.8333H18.1667C17.7246 14.8333 17.3007 14.6577 16.9882 14.3452C16.6756 14.0326 16.5 13.6087 16.5 13.1667Z",
    stroke: "#0B54A0",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryIcon);
export default __webpack_public_path__ + "static/media/SalaryIcon.b9e17e161a42936845e886a50ebb4760.svg";
export { ForwardRef as ReactComponent };